// extracted by mini-css-extract-plugin
export default {"title":"style_title__0f+-j","container":"style_container__fNLvM"};